import React from 'react';
import { useOnboardingSetup } from '../OnboardingSetupContext';
import { useGlobal } from '../../Context/GlobalContext';
import { createBrandApi, updateBrandApi } from '../utils/brandApiHelpers';
import SetupModal from './SetupModal';

const GlobalSetupModal = () => {
  const {
    showSetupModal,
    formData,
    setFormData,
    brandType,
    logoPreview,
    setLogoPreview,
    brandCreated,
    setBrandCreated,
    aiSuggestions,
    fileInputRef,
    closeSetupModal,
  } = useOnboardingSetup();

  const { apiUrl } = useGlobal();

  if (!showSetupModal) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      if (file.size > 3 * 1024 * 1024) {
        return;
      }
      setFormData(prev => ({ ...prev, logo: file }));
      setLogoPreview(URL.createObjectURL(file));
    }
  };

  const handleRemoveLogo = () => {
    setFormData(prev => ({ ...prev, logo: null }));
    setLogoPreview(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const handleCreateBrand = async () => {
    await createBrandApi({ apiUrl, formData, brandType });
    setBrandCreated(true);
    localStorage.setItem('onboarding_completed', 'true');
  };

  const handleUpdateBrand = async () => {
    try {
      await updateBrandApi({ apiUrl, formData });
    } catch (err) {
      // Silent fail for auto-save
    }
  };

  return (
    <SetupModal
      show={showSetupModal}
      onClose={closeSetupModal}
      formData={formData}
      onChange={handleInputChange}
      brandType={brandType}
      logoPreview={logoPreview}
      onFileChange={handleFileChange}
      onRemoveLogo={handleRemoveLogo}
      fileInputRef={fileInputRef}
      onCreateBrand={handleCreateBrand}
      onUpdateBrand={handleUpdateBrand}
      brandCreated={brandCreated}
      aiSuggestions={aiSuggestions}
    />
  );
};

export default GlobalSetupModal;
